import { MessageBox } from 'element-ui'

export function confirm(message = '此操作将永久删除, 是否继续?') {
  return new Promise((resolve, reject) => {
    MessageBox.confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      resolve(true)
    }).catch(() => {
      reject(false)
    })
  })
}

